// Treat relative URLs (resolve to nav's own origin) and absolute URLs on any
// Dexibit domain as "ours". Used to gate auth-sensitive actions like 401 redirects
// and cross-frame postMessage trust so third-party responses can't trigger them.
const DEXIBIT_HOSTS = ["dexibit.com", "dexibit.io"];

export const isDexibitApi = (url: string | undefined): boolean => {
  if (!url) return false;
  try {
    const parsed = new URL(url, window.location.origin);
    if (parsed.origin === window.location.origin) return true;
    const { hostname } = parsed;
    // Exact match or a subdomain — avoids lookalikes like "evildexibit.com".
    return DEXIBIT_HOSTS.some(
      (host) => hostname === host || hostname.endsWith(`.${host}`),
    );
  } catch {
    return false;
  }
};
